var _OptionServiceInit_timestamp, _OptionServiceInit_enableBot, _OptionServiceInit_enableCheckerBar, _OptionServiceInit_enableCheckerRightAlign, _OptionServiceInit_enableDataSave, _OptionServiceInit_chatViewOffset, _OptionServiceInit_volume, _OptionServiceInit_localStorage;
import { __classPrivateFieldGet } from "tslib";
import { writable } from 'svelte/store';
import { LocalStorageManager } from '../model/storage/LocalStorageManager';
class OptionServiceInit {
    constructor() {
        _OptionServiceInit_timestamp.set(this, writable(false));
        _OptionServiceInit_enableBot.set(this, writable(true));
        _OptionServiceInit_enableCheckerBar.set(this, writable(true));
        _OptionServiceInit_enableCheckerRightAlign.set(this, writable(false));
        _OptionServiceInit_enableDataSave.set(this, writable(false));
        _OptionServiceInit_chatViewOffset.set(this, writable(300));
        _OptionServiceInit_volume.set(this, writable(50));
        _OptionServiceInit_localStorage.set(this, new LocalStorageManager());
        __classPrivateFieldGet(this, _OptionServiceInit_timestamp, "f").set(__classPrivateFieldGet(this, _OptionServiceInit_localStorage, "f").timestamp);
        __classPrivateFieldGet(this, _OptionServiceInit_enableBot, "f").set(__classPrivateFieldGet(this, _OptionServiceInit_localStorage, "f").enableBot);
        __classPrivateFieldGet(this, _OptionServiceInit_enableCheckerBar, "f").set(__classPrivateFieldGet(this, _OptionServiceInit_localStorage, "f").enableCheckerBar);
        __classPrivateFieldGet(this, _OptionServiceInit_enableCheckerRightAlign, "f").set(__classPrivateFieldGet(this, _OptionServiceInit_localStorage, "f").enableCheckerRightAlign);
        __classPrivateFieldGet(this, _OptionServiceInit_enableDataSave, "f").set(__classPrivateFieldGet(this, _OptionServiceInit_localStorage, "f").enableDataSave);
        __classPrivateFieldGet(this, _OptionServiceInit_chatViewOffset, "f").set(__classPrivateFieldGet(this, _OptionServiceInit_localStorage, "f").chatViewOffset);
        __classPrivateFieldGet(this, _OptionServiceInit_volume, "f").set(__classPrivateFieldGet(this, _OptionServiceInit_localStorage, "f").volume);
    }
    get timestamp() {
        return __classPrivateFieldGet(this, _OptionServiceInit_timestamp, "f");
    }
    get enableBot() {
        return __classPrivateFieldGet(this, _OptionServiceInit_enableBot, "f");
    }
    get enableCheckerBar() {
        return __classPrivateFieldGet(this, _OptionServiceInit_enableCheckerBar, "f");
    }
    get enableCheckerRightAlign() {
        return __classPrivateFieldGet(this, _OptionServiceInit_enableCheckerRightAlign, "f");
    }
    get enableDataSave() {
        return __classPrivateFieldGet(this, _OptionServiceInit_enableDataSave, "f");
    }
    get chatViewOffset() {
        return __classPrivateFieldGet(this, _OptionServiceInit_chatViewOffset, "f");
    }
    get volume() {
        return __classPrivateFieldGet(this, _OptionServiceInit_volume, "f");
    }
    setTimestamp(value) {
        __classPrivateFieldGet(this, _OptionServiceInit_timestamp, "f").set(value);
        __classPrivateFieldGet(this, _OptionServiceInit_localStorage, "f").timestamp = value;
    }
    setEnableBot(value) {
        __classPrivateFieldGet(this, _OptionServiceInit_enableBot, "f").set(value);
        __classPrivateFieldGet(this, _OptionServiceInit_localStorage, "f").enableBot = value;
    }
    setEnableCheckerBar(value) {
        __classPrivateFieldGet(this, _OptionServiceInit_enableCheckerBar, "f").set(value);
        __classPrivateFieldGet(this, _OptionServiceInit_localStorage, "f").enableCheckerBar = value;
    }
    setEnableCheckerRightAlign(value) {
        __classPrivateFieldGet(this, _OptionServiceInit_enableCheckerRightAlign, "f").set(value);
        __classPrivateFieldGet(this, _OptionServiceInit_localStorage, "f").enableCheckerRightAlign = value;
    }
    setEnableDataSave(value) {
        __classPrivateFieldGet(this, _OptionServiceInit_enableDataSave, "f").set(value);
        __classPrivateFieldGet(this, _OptionServiceInit_localStorage, "f").enableDataSave = value;
    }
    setChatViewOffset(value) {
        __classPrivateFieldGet(this, _OptionServiceInit_chatViewOffset, "f").set(value);
        __classPrivateFieldGet(this, _OptionServiceInit_localStorage, "f").chatViewOffset = value;
    }
    setVolume(value) {
        __classPrivateFieldGet(this, _OptionServiceInit_volume, "f").set(value);
        __classPrivateFieldGet(this, _OptionServiceInit_localStorage, "f").volume = value;
    }
}
_OptionServiceInit_timestamp = new WeakMap(), _OptionServiceInit_enableBot = new WeakMap(), _OptionServiceInit_enableCheckerBar = new WeakMap(), _OptionServiceInit_enableCheckerRightAlign = new WeakMap(), _OptionServiceInit_enableDataSave = new WeakMap(), _OptionServiceInit_chatViewOffset = new WeakMap(), _OptionServiceInit_volume = new WeakMap(), _OptionServiceInit_localStorage = new WeakMap();
export const OptionService = new OptionServiceInit();
